
<div class="docWrapper">
  <div class="docCont">
    <div class="formtools">


        <mat-card class="toolHolder" *ngIf="isPageLoaded && !IsSigningComplete && !isReadOnlyGroupParticipant">

          <div class="expand">

          <!-- <button *ngIf="!isDrawing"  mat-icon-button  matTooltipClass="tooltip" [ngClass]="{'active': flash }" (click)="flashFields()"
               matTooltip="AUTO FILL WILL USE PAST VALUES"><mat-icon>flash_auto</mat-icon></button> -->
              <!-- <div *ngIf="!isDrawing"  class="sepreator"></div> -->



          <!-- <ng-container *ngIf="!isDrawing">
            <span class="" *ngIf="(!IsSigningComplete)">
              <button class="newBtn" color="warn" matTooltipClass="tooltip" (click)="fillForms(fillForm)" matTooltip="Move Next"
                mat-icon-button (click)="movetoNextControl()">
                <mat-icon>arrow_forward_ios</mat-icon>
                <span>Next</span>
              </button>
            </span>
          </ng-container> -->
          <button class="fileIcon" matBadge="{{pjtDocumentImgThumbs.length}}" matBadgeColor="warn"
          (click)="showAllFiles()" mat-icon-button><mat-icon>insert_drive_file</mat-icon></button>
        <div class="sepreator fileIcon"></div>

        <button class="finish finishButtonWorkAround" color="primary"  [attr.disabled]="IsSigningComplete"
        (click)="SignatureAcceptance(acceptFinish)" mat-flat-button>Finish
        </button>        
        
          <button *ngIf="isDrawing" class="finish" color="primary" (click)="drawonImg()" mat-icon-button>
            <mat-icon>check_circle_outline</mat-icon>
          </button>
          <div class="sepreator"></div>
          <button *ngIf="isDrawing" class="finish" color="basic" (click)="Cleardrawing()" mat-icon-button>
            <mat-icon>highlight_off</mat-icon>
          </button>

          <button color="primary" class="saveBtn newBtn" *ngIf="!isDrawing && showSaveRecordbtn==true" mat-icon-button matTooltipClass="tooltip"
            matTooltip="Save" (click)="SaveRecord()">
            <mat-icon>save</mat-icon>
            <span>Save</span>
          </button>
          <div class="sepreator" *ngIf="!isDrawing && showSaveRecordbtn==true"></div>
          <!-- <button color="primary" mat-icon-button matTooltip="Download document" matTooltipClass="tooltip"
            (click)="SaveRecord(true)">
            <mat-icon>file_download</mat-icon>
          </button> -->
          <div class="sepreator" *ngIf="!isDrawing && showSaveRecordbtn==true"></div>
         
        
        </div>

        </mat-card>

        <mat-card class="toolHolder" *ngIf="isPageLoaded && IsSigningComplete">
          <div class="sepreator"></div>
          <p>You have already finished the form.</p>
          <div class="sepreator"></div>
          <!-- <button color="primary" mat-icon-button matTooltip="Download document" matTooltipClass="tooltip"
            (click)="PDFDownload()">
            <mat-icon>file_download</mat-icon>
          </button> -->
          <!-- <button color="primary" class="finish" *ngIf="ProjectFinishBySenderButton"
            (click)="ProjectFinishBySendersButton()" mat-flat-button>Finish </button> -->
        </mat-card>


        <mat-card class="toolHolder" *ngIf="isReadOnlyGroupParticipant">
          <div class="sepreator"></div>
          <p>You have read only permission.</p>

          <div class="sepreator"></div>
          <!-- <button color="primary" mat-icon-button matTooltip="Download document" matTooltipClass="tooltip"
            (click)="PDFDownload()">
            <mat-icon>file_download</mat-icon>
          </button> -->
          <div class="sepreator"></div>
           <button color="primary" class="saveBtn newBtn"  *ngIf="(isProgressiveForm==true ||isReadOnlyGroupParticipant==true ) && !isDrawing && showSaveRecordbtn==true" mat-icon-button matTooltipClass="tooltip"
            matTooltip="Save" (click)="SaveRecord(false,true,true)">
            <mat-icon>save</mat-icon>
            <span>Save</span>
          </button>

          <!-- for web -->
          <div *ngIf="IsApprover==true && IsAcceptParticipant==0 && (IsAccept==0 || IsAccept==1) " class="sepreator"></div>
       
          <button class="deviceBtn" *ngIf="IsApprover==true && IsAcceptParticipant==0 &&  (IsAccept==0 || IsAccept==1)" color="primary" mat-icon-button matTooltip="Approve" (click)="AcceptBtnClick(1)" matTooltipClass="tooltip">
            <mat-icon>check_circle</mat-icon>
          </button>                  

          
        </mat-card>


    </div>


  

    <div class="docSign" id="docSign" #content>

      <div class="fixedIcons" *ngIf="!IsSigningComplete">
        <!-- <button (click)="declineProject(decline)" matTooltip="Decline Form" ><mat-icon>thumb_down_alt</mat-icon> <span class="text" >Decline Form</span></button> -->
        <!-- <button mat-menu-item (click)="assignOther(assignAnother)" ><mat-icon>assignment_turned_in</mat-icon> Assign to other</button> -->
        <button (click)="clickTextField(true)" matTooltip="Add text field"><mat-icon>power_input</mat-icon> <span class="text" >Add text field</span></button>
        <button (click)="clickInitialsField(true)" matTooltip="Add Initials"><mat-icon>gesture</mat-icon> <span class="text" >Add initials</span></button>
        <button (click)="clickSignatureField(true)" matTooltip="Add Signature"><mat-icon>create</mat-icon> <span class="text" >Add signature</span></button>
        <!-- <button class="showInMobile" matTooltip="Required fields" *ngIf="!isDrawing"  (click)="highlightRequiredControls()">
         <mat-icon>verified</mat-icon> <span class="text">Required fields</span>
        </button> -->
       <button *ngIf="!isDrawing"  matTooltip="Draw" (click)="drawonImg()"><mat-icon>draw</mat-icon> <span class="text" >Draw</span></button>
        <button  matTooltip="Clear Form" (click)="clearForm()"><mat-icon>format_clear</mat-icon> <span class="text" >Clear Form</span></button>
        <!-- <button (click)="openPopUpAssignToSomeOne(addAssignToSomeOne)" matTooltip="Reassign Signer"><mat-icon>assignment_ind</mat-icon> <span class="text" >Reassign Signer</span></button>
        <button (click)="ClearSignNowSignature()" *ngIf="SignType==1" matTooltip="Clear Signature"><mat-icon>clear_all</mat-icon> <span class="text" >Clear Signature</span></button> -->
      </div>

      <div class="FormResizer">


        <div class="docHolding" [attr.style]="setPagePageStyle(i)? 'page-break-after: always;' : null"
          *ngFor="let item of particiantJsonList;let i= index;" id=docHolding{{i+1}}>

          <div class="iframe-drag-bounds" #dragBounds>
            <app-canvas [height]="setHeight(i)" [width]="setWidth(i)" [canvasIndex]="i"
              (newItemEvent)="setIndex($event,selectedDocumentId)" *ngIf="isDrawing"></app-canvas>

            <ng-container *ngFor="let field of item.fields;let j= index;">

              <ng-container *ngIf="field.fieldTypeName!=='Checkbox' && field.fieldTypeName!=='Radio'
                && field.fieldTypeName!=='CheckBoxGroup' && field.fieldTypeName!=='Image'">
                <div class="iframe-resize-container"
                  [id]="'container-' + field.id"
                  [ngClass]="{'fileControl' :field.fieldTypeName=='Draw' || field.fieldTypeName=='Signature' || field.fieldTypeName=='Initials'  }"
                  [ngStyle]="{'position': 'absolute','width': field.fieldTypeName=='AITextBox'? '100%': field.offsetWidth+'px','height': field.offsetHeight+'px','transform': 'translate('+field.offsetX + 'px,'+ field.offsetY + 'px)'}"
                  [ngStyle]="{'position': 'absolute','width': field.fieldTypeName=='State'? '33px': field.offsetWidth+'px','height': field.offsetHeight+'px','transform': 'translate('+field.offsetX + 'px,'+ field.offsetY + 'px)'}"
                  [ngClass]="{'ng-show-required' : field.showRequiredControls}"
                  (click)="verifyParticipant(field,$event)">

                  <div class="iframe-drag-handle" id="dh{{field.id}}" (click)="addActiveClass(field)"
                    [ngStyle]="{'transform':'rotate('+field.rotation+'deg)'}" [attr.field]="field.id"
                    [attr.tabIndex]="setTabIndex(i,j)"
                    [ngClass]="{'state-control': field.fieldTypeName == 'State'}"
                    #dragHandle>
  

                    <ng-container *ngIf="field.fieldTypeName=='Textbox' && field.Control!='Static'">
                    
                      <input 
                      [disabled]="field.isDisabled"
                      matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}"
                      matTooltipShowDelay="2500"
                      matTooltipClass="tooltip" 
                      *ngIf="field.isEditable==false "
                      [maxlength]="field.charLimit"
                      [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily
                       ,'width': field.offsetWidth+'px','height': field.offsetHeight+'px', 'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"
                      [maxlength]="field.charLimit" 
                      (input)="onChange($event.target.value,item,field)"
                      [attr.value]="field.selectedValue" 
                      type="text" 
                      [(ngModel)]='field.selectedValue'
                      id="{{field.id}}" 
                      placeholder="{{field.fieldName}}"
                      [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                      style="width: auto;"
                     
                      #autoInput
                
                     (ngModelChange)="field.selectedValue = $event; field.fieldName !== 'Address' && updateInputWidth($event, field.id)"
                    (input)="field.fieldName !== 'Address' && onChangeInputValue($event, field)"

                        >

                          <span #mirrorSpan
                            [id]="'mirror-' + field.id"
                            style="position: absolute; visibility: hidden; white-space: pre; font-size: inherit; font-family: inherit;  
                            padding: 0;border: 0;">
                          </span>

                      <input [disabled]="field.isDisabled"
                        matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}"
                        matTooltipShowDelay="2500" matTooltipClass="tooltip" *ngIf="field.isEditable==true"
                        [maxlength]="field.charLimit"
                        [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily
                       ,'width': field.offsetWidth+'px','height': field.offsetHeight+'px', 'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"
                        [maxlength]="field.charLimit" (input)="onChange($event.target.value,item,field)"
                        [attr.value]="field.selectedValue" type="text" [(ngModel)]='field.selectedValue'
                        [placeholder]="field.isShowAllEditablePlaceHolders? field.fieldName : '' "
                        id="{{field.id}}" [ngClass]="{'ng-active' : field.ShowtoolDetail}">
                    </ng-container>
                 

                    <ng-container *ngIf="field.fieldTypeName=='Textarea'">
                      <textarea
                        matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}"
                        matTooltipShowDelay="2500" matTooltipClass="tooltip" [disabled]="field.isDisabled"
                        *ngIf="field.isEditable==false" cdkTextareaAutosize cdkAutosizeMinRows="1"
                        cdkAutosizeMaxRows="5"
                        [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily
                       ,'width': field.offsetWidth+'px','height': field.offsetHeight+'px', 'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"
                        [maxlength]="field.charLimit" [innerHTML]="field.selectedValue"
                        [(ngModel)]='field.selectedValue' (input)="onChangeTexarea($event.target.value,item,field)"
                        (click)="OpentoolDetail('Textarea')" class="form-control" id="{{field.id}}"
                        placeholder="{{field.fieldName}}" [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                        [maxlength]="field.charLimit" (click)="OpentoolDetailText(item,field.id)"></textarea>

                      <textarea
                        matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}"
                        matTooltipShowDelay="2500" matTooltipClass="tooltip" [disabled]="field.isDisabled"
                        *ngIf="field.isEditable==true" cdkTextareaAutosize cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5"
                        [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily
                         ,'width': field.offsetWidth+'px','height': field.offsetHeight+'px', 'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"
                        [maxlength]="field.charLimit" [innerHTML]="field.selectedValue"
                        [(ngModel)]='field.selectedValue' (input)="onChangeTexarea($event.target.value,item,field)"
                        (click)="OpentoolDetail('Textarea')" class="form-control" id="{{field.id}}"
                        placeholder="{{field.fieldName}}" [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                        (click)="OpentoolDetailText(item,field.id)"></textarea>
                    </ng-container>

                    <ng-container *ngIf="field.fieldTypeName=='Number'">
                      <input
                        matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}"
                        matTooltipShowDelay="2500" matTooltipClass="tooltip" [disabled]="field.isDisabled"
                        [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight,
                         'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily
                        ,'width': field.offsetWidth+'px','height': field.offsetHeight+'px','border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')','transform':'rotate('+field.rotation+'deg)'}"
                        placeholder="{{field.fieldName}}" [(ngModel)]='field.selectedValue'
                        [attr.value]="field.selectedValue" type="text" class="form-control" id="{{field.id}}"
                        (input)="onChange($event.target.value,item,field)" (click)="OpentoolDetail('Number')"
                        [maxlength]="field.charLimit" (keypress)="numberOnly($event)" id="{{field.id}}"
                        (click)="OpentoolDetailText(item,field.id)" [ngClass]="{'ng-active' : field.ShowtoolDetail}">
                    </ng-container>
                                                        

                    <ng-container *ngIf="field.fieldTypeName=='File'">
                      <div matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}"
                        matTooltipShowDelay="2500" matTooltipClass="tooltip" *ngIf="field.isDisabled"
                        style="background-color:#dddddd;cursor: not-allowed; pointer-events: all !important;border: 2px solid rgba(118, 118, 118, 0.3)!important;"
                        [class.disabled]="field.isDisabled" class="customUpdate" (click)="OpentoolDetail('File')"
                        id="{{field.id}}" (click)="OpentoolDetailText(item,field.id)"
                        [ngClass]="{'ng-active' : field.ShowtoolDetail}">
                        <span id="cloud_upload" *ngIf='field.FileData.length==0'
                          style="cursor: not-allowed; pointer-events: all !important;">
                          <mat-icon>cloud_upload</mat-icon>
                          Upload File
                        </span>

                        <div *ngFor="let file of field.FileData" class="uploadedData"
                          style="cursor: not-allowed; pointer-events: all !important;">
                          <p>{{file.FullPath}}</p>
                        </div>
                        <input type="file" class="form-control" id="{{field.fieldName}}"
                          (change)="onSelectFile($event,item,field.id)" placeholder="{{field.fieldName}}">
                      </div>
                      <div matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}"
                        matTooltipShowDelay="2500" matTooltipClass="tooltip" *ngIf="!field.isDisabled"
                        [class.disabled]="field.isDisabled" class="customUpdate" (click)="OpentoolDetail('File')"
                        id="{{field.id}}" (click)="OpentoolDetailText(item,field.id)"
                        [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                        [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}">
                        <span id="cloud_upload" *ngIf='field.FileData.length==0'>
                          <mat-icon>cloud_upload</mat-icon>
                          Upload File
                        </span>

                        <div *ngFor="let file of field.FileData" class="uploadedData">
                          <p>{{file.FullPath}}</p>
                        </div>
                        <input type="file" class="form-control" id="{{field.fieldName}}"
                          (change)="onSelectFile($event,item,field.id)" placeholder="{{field.fieldName}}">
                      </div>
                    </ng-container>

                    <ng-container *ngIf="field.fieldTypeName=='Signature' && field.Control!='Static'">
                      <div matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}"
                        matTooltipShowDelay="2500" matTooltipClass="tooltip" *ngIf="field.isDisabled"
                        [class.disabled]="field.isDisabled" id="{{field.id}}" class="customUpdate"
                        [ngClass]="{'ng-active' : field.ShowtoolDetail && !field.isDisabled}" [ngClass]="{'backgroundGrey' : field.isDisabled}">
                        <span id="border_color"
                          *ngIf='!field.signatureBase64 && !field.signatureText && field.ImageData.length==0'
                          style="cursor: not-allowed; pointer-events: all !important;">
                          <mat-icon>border_color</mat-icon>
                          Signature
                        </span>


                        <!-- Signature Stamp-->
                        <div class="sig-cell"
                          *ngIf='field.signatureBase64 || field.signatureText && !field.signatureBase64 || field.ImageData.length>0'
                          [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                          <div class="sig-chrome"
                            [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                            <div class="sig-chrome-title-top ng-scope" translate="flowtrics by:">By flowtrics</div>
                            <div class="sig-container"
                              [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                              <img *ngIf='field.signatureBase64' [src]="field.signatureBase64" />
                              <ng-container *ngIf='field.signatureText && !field.signatureBase64'>
                                <h3 [ngStyle]="{'font-family': field.signInitialFontFamily}">{{field.signatureText}}
                                </h3>
                              </ng-container>

                              <div *ngFor="let img of field.ImageData" class="uploadedData"
                                [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                                <img [src]="img.Imageurl" [class.disabled]="field.isDisabled" />
                              </div>

                            </div>
                            <div class="sig-chrome-title-bottom ng-binding">{{field.participantEmailId}}</div>
                            <!-- <div class="sig-chrome-title-bottom ng-binding">{{participantEmailId}}</div> -->
                          </div>
                        </div>
                        <!-- Signature Stamp-->
                        <!-- <img *ngIf='field.signatureBase64' [src]="field.signatureBase64" [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}" />

                          <ng-container  *ngIf='field.signatureText && !field.signatureBase64'>
                          <h3 [ngStyle]="{'font-family': field.signInitialFontFamily}" >{{field.signatureText}}</h3>
                         </ng-container>
                          <div *ngFor="let img of field.ImageData" class="uploadedData">
                            <img [src]="img.Imageurl" [class.disabled]="field.isDisabled"  [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}"/>
                         </div>  -->
                      </div>

                      <div matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}"
                        matTooltipShowDelay="2500" matTooltipClass="tooltip" *ngIf="!field.isDisabled"
                        [class.disabled]="field.isDisabled" id="{{field.id}}" class="customUpdate"
                        [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"
                        [ngClass]="{'bnone' : field.signatureBase64 || field.signatureText && !field.signatureBase64 || field.ImageData.length>0,'ng-active' : field.ShowtoolDetail }"
                        (click)="OpenSignPopup(AddSignature,item,field)">
                        <span id="border_color"
                          *ngIf='!field.signatureBase64 && !field.signatureText && field.ImageData.length==0'>
                          <mat-icon>border_color</mat-icon>
                          Signature
                        </span>

                        <!-- Signature Stamp-->
                        <div class="sig-cell"
                          *ngIf='field.signatureBase64 || field.signatureText && !field.signatureBase64 || field.ImageData.length>0'
                          [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                          <div class="sig-chrome"
                            [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                            <div class="sig-chrome-title-top ng-scope" translate="flowtrics by:">By flowtrics</div>
                            <div class="sig-container"
                              [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                              <img *ngIf='field.signatureBase64' [src]="field.signatureBase64" />
                              <ng-container *ngIf='field.signatureText && !field.signatureBase64'>
                                <h3 [ngStyle]="{'font-family': field.signInitialFontFamily}">{{field.signatureText}}
                                </h3>
                              </ng-container>

                              <div *ngFor="let img of field.ImageData" class="uploadedData"
                                [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                                <img [src]="img.Imageurl" [class.disabled]="field.isDisabled" />
                              </div>

                            </div>
                            <!-- <div class="sig-chrome-title-bottom ng-binding">{{participantEmailId}}</div> -->
                            <div class="sig-chrome-title-bottom ng-binding">{{field.participantEmailId}}</div>
                          </div>
                        </div>
                        <!-- Signature Stamp-->


                        <!-- <img *ngIf='field.signatureBase64' [src]="field.signatureBase64" [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}" />

                          <ng-container  *ngIf='field.signatureText && !field.signatureBase64'>
                          <h3 [ngStyle]="{'font-family': field.signInitialFontFamily}" >{{field.signatureText}}</h3>
                         </ng-container>
                          <div *ngFor="let img of field.ImageData" class="uploadedData">
                            <img [src]="img.Imageurl" [class.disabled]="field.isDisabled"  [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}"/>
                         </div>
                          -->


                      </div>
                    </ng-container>

                    <ng-container *ngIf="field.fieldTypeName=='Initials' && field.Control!='Static'">
                      <div matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}"
                        matTooltipShowDelay="2500" matTooltipClass="tooltip" *ngIf="field.isDisabled"
                        [class.disabled]="field.isDisabled" id="{{field.id}}" class="customUpdate"
                        [ngClass]="{'ng-active' : field.ShowtoolDetail && !field.isDisabled}"  [ngClass]="{'backgroundGrey' : field.isDisabled}">
                        <span id="initial_gesture"
                          *ngIf='!field.signatureBase64 && !field.signatureText && field.ImageData.length==0'
                          style="cursor: not-allowed; pointer-events: all !important;">
                          <mat-icon>gesture</mat-icon>
                          Initials
                        </span>
                        <!-- Initials Stamp-->
                        <div class="sig-cell"
                          *ngIf='field.signatureBase64 || field.signatureText && !field.signatureBase64 || field.ImageData.length>0'
                          [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                          <div class="sig-chrome"
                            [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                            <div class="sig-chrome-title-top ng-scope" translate="flowtrics by:">By flowtrics</div>
                            <div class="sig-container">
                              <img *ngIf='field.signatureBase64' [src]="field.signatureBase64" />
                              <ng-container *ngIf='field.signatureText && !field.signatureBase64'>
                                <h3 [ngStyle]="{'font-family': field.signInitialFontFamily}">{{field.signatureText}}
                                </h3>
                              </ng-container>

                              <div *ngFor="let img of field.ImageData" class="uploadedData"
                                [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                                <img [src]="img.Imageurl" [class.disabled]="field.isDisabled" />
                              </div>

                            </div>
                            <div class="sig-chrome-title-bottom ng-binding">{{field.participantEmailId}}</div>
                          </div>
                        </div>
                        <!-- Initials Stamp-->

                      </div>

                      <div matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}"
                        matTooltipShowDelay="2500" matTooltipClass="tooltip" *ngIf="!field.isDisabled"
                        [class.disabled]="field.isDisabled" id="{{field.id}}" class="customUpdate"
                        [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"
                        [ngClass]="{'ng-active' : field.ShowtoolDetail,'bnone' : field.signatureBase64 || field.signatureText && !field.signatureBase64 || field.ImageData.length>0 }"
                        (click)="OpenSignPopup(AddInitial,item,field)">
                        <span id="initial_gesture"
                          *ngIf='!field.signatureBase64 && !field.signatureText && field.ImageData.length==0'>
                          <mat-icon>gesture</mat-icon>
                          Initials
                        </span>

                        <!-- Initials Stamp-->
                        <div class="sig-cell"
                          *ngIf='field.signatureBase64 || field.signatureText && !field.signatureBase64 || field.ImageData.length>0'
                          [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                          <div class="sig-chrome"
                            [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                            <div class="sig-chrome-title-top ng-scope" translate="flowtrics by:">By flowtrics</div>
                            <div class="sig-container">
                              <img *ngIf='field.signatureBase64' [src]="field.signatureBase64" />
                              <ng-container *ngIf='field.signatureText && !field.signatureBase64'>
                                <h3 [ngStyle]="{'font-family': field.signInitialFontFamily}">{{field.signatureText}}
                                </h3>
                              </ng-container>

                              <div *ngFor="let img of field.ImageData" class="uploadedData"
                                [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                                <img [src]="img.Imageurl" [class.disabled]="field.isDisabled" />
                              </div>

                            </div>
                            <div class="sig-chrome-title-bottom ng-binding">{{field.participantEmailId}}</div>
                          </div>
                        </div>
                        <!-- Initials Stamp-->

                      </div>
                    </ng-container>                                             
                  
                  </div>
                </div>
              </ng-container>
           

              <ng-container *ngIf="field.fieldTypeName=='Image'">
                <div class="radioHolder" id="{{field.id}}">
                  <div *ngFor="let ele of field.fillList; let i=index" class="iframe-resize-container"
                    [attr.field]="field.id" [ngClass]="{'fileControl' :field.fieldTypeName=='Image'}"
                    [ngStyle]="{'height': field.Imageheight, 'width': field.Imagewidth,'transform': 'translate('+field.offsetX + 'px,'+ field.offsetY + 'px)'}"
                    style="position: absolute" (click)="verifyParticipant(field,$event)">

                    <div class="iframe-drag-handle" id="dh{{field.id}}" (click)="addActiveClass(field)"
                      [attr.field]="field.id" [attr.tabIndex]="setTabIndex(i,j)" #dragHandle>

                      <ng-container *ngIf="field.fieldTypeName=='Image'">
                        <div
                          matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}"
                          matTooltipShowDelay="2500" matTooltipClass="tooltip" *ngIf="field.isDisabled"
                          style="background-color:#dddddd;cursor: not-allowed; pointer-events: all !important;border: 2px solid rgba(118, 118, 118, 0.3)!important;"
                          class="customUpdate" [class.disabled]="field.isDisabled" (click)="OpentoolDetail('Image')"
                          id="{{field.id}}" (click)="OpentoolDetailText(item,field.id)"
                          [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                          [ngClass]="{'ng-show-required' : field.showRequiredControls}">
                          <span id="cloud_upload" *ngIf='field.ImageData.length==0'
                            style="cursor: not-allowed; pointer-events: all !important;">
                            <mat-icon>cloud_upload</mat-icon>
                            Upload Image
                          </span>
                          <div *ngFor="let img of field.ImageData" class="uploadedData">
                            <img *ngIf='img.Imageurl' [src]="img.Imageurl" [class.disabled]="field.isDisabled"
                              [ngStyle]="{'height': field.Imageheight, 'width': field.Imagewidth}" />
                          </div>

                          <input type="file" class="form-control" accept="image/*" id="{{field.fieldName}}"
                            (change)="onSelectImage($event,item,field.id)" placeholder="{{field.fieldName}}">
                        </div>

                        <div
                          matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}"
                          matTooltipShowDelay="2500" matTooltipClass="tooltip" *ngIf="!field.isDisabled"
                          class="customUpdate" [class.disabled]="field.isDisabled" (click)="OpentoolDetail('Image')"
                          id="{{field.id}}" (click)="OpentoolDetailText(item,field.id)"
                          [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"
                          [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                          [ngClass]="{'ng-show-required' : field.showRequiredControls}">
                          <span id="cloud_upload" *ngIf='field.ImageData.length==0'>
                            <mat-icon>cloud_upload</mat-icon>
                            Upload Image
                          </span>
                          <div *ngFor="let img of field.ImageData" class="uploadedData">
                            <img *ngIf='img.Imageurl' [src]="img.Imageurl" [class.disabled]="field.isDisabled"
                              [ngStyle]="{'height': field.Imageheight, 'width': field.Imagewidth}" />
                          </div>

                          <input type="file" class="form-control" accept="image/*" id="{{field.fieldName}}"
                            (change)="onSelectImage($event,item,field.id)" placeholder="{{field.fieldName}}">
                        </div>
                      </ng-container>


                    </div>
                  </div>
                </div>
              </ng-container>


              <ng-container *ngIf="field.fieldTypeName=='Textbox' && field.Control=='Static'">
                <div [ngClass]="{'disableDiv': isPageLoaded && IsSigningComplete}" class="iframe-resize-container"
                  [position]="{x: field.offsetX, y:field.offsetY}" style="position: absolute;"
                  [ngResizable]="!field.isDisabled"
                  [ngStyle]="{'position': 'absolute','width': field.offsetWidth+'px','height': field.offsetHeight+'px'}"
                  rzHandles="n,s,e,w,se,sw" [ngDraggable]="!field.isDisabled" [handle]="dragHandle"
                  (stopped)="onStop($event)" (movingOffset)="onMoving($event,item)"
                  (endOffset)="onMoveEnd($event,item,field,'')" (rzStop)="onResizeStop($event,item,field.id)"
                  [inBounds]="true">
                

                  <div class="iframe-drag-handle" id="dh{{field.id}}" [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                    [ngStyle]="{'transform':'rotate('+field.rotation+'deg)'}" #dragHandle>

                    <ng-container *ngIf="field.fieldTypeName=='Textbox' && field.Control=='Static'">
                      <input [disabled]="field.isDisabled"
                        matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}"
                        matTooltipShowDelay="2500" matTooltipClass="tooltip"
                        [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily
                        ,'width': field.offsetWidth+'px','height': field.offsetHeight+'px'  , 'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"
                        [maxlength]="field.charLimit" (input)="onChange($event.target.value,item,field)"
                        [ngClass]="{'ng-active' : field.ShowtoolDetail}" [attr.value]="field.selectedValue" type="text"
                        [(ngModel)]='field.selectedValue' id="{{field.id}}" placeholder="{{field.fieldName}}">
                    </ng-container>

                  </div>
                </div>
              </ng-container>


              <ng-container
                *ngIf="(field.fieldTypeName=='Signature' || field.fieldTypeName=='Initials') && field.Control=='Static'">
                <div [ngClass]="{'disableDiv': isPageLoaded && IsSigningComplete}" class="iframe-resize-container"
                  [position]="{x: field.offsetX, y:field.offsetY}" style="position: absolute;"
                  [ngResizable]="!field.isDisabled" [rzAspectRatio]="true" [rzMinWidth]="40" [rzMaxWidth]="160"
                  [rzMinHeight]="27" [rzMaxHeight]="105"
                  [ngStyle]="{'position': 'absolute','width': field.offsetWidth+'px','height': field.offsetHeight+'px'}"
                  rzHandles="n,s,e,w,se,sw" [ngDraggable]="!field.isDisabled" [handle]="dragHandle"
                  (stopped)="onStop($event)" (movingOffset)="onMoving($event,item)"
                  (endOffset)="onMoveEnd($event,item,field,'')" (rzStop)="onResizeStop($event,item,field.id)"
                  [inBounds]="true">

                  <!-- [bounds]="dragBounds" -->
                  <!-- [appDisable]="field.isDisabled" -->

                  <div class="iframe-drag-handle" id="dh{{field.id}}"
                    [ngStyle]="{'transform':'rotate('+field.rotation+'deg)'}" #dragHandle>

                    <ng-container *ngIf="field.fieldTypeName=='Signature' && field.Control=='Static'">
                      <div matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}"
                        matTooltipShowDelay="2500" matTooltipClass="tooltip" *ngIf="field.isDisabled"
                        style="background-color:#dddddd;cursor: not-allowed; pointer-events: all !important;border: 2px solid rgba(118, 118, 118, 0.3)!important;"
                        [class.disabled]="field.isDisabled" id="{{field.id}}" class="customUpdate"
                        [ngClass]="{'ng-active' : field.ShowtoolDetail}">
                        <span id="border_color"
                          *ngIf='!field.signatureBase64 && !field.signatureText && field.ImageData.length==0'
                          style="cursor: not-allowed; pointer-events: all !important;">
                          <mat-icon>border_color</mat-icon>
                          Signature
                        </span>
                        <!-- Signature Stamp-->
                        <div class="sig-cell"
                          *ngIf='field.signatureBase64 || field.signatureText && !field.signatureBase64 || field.ImageData.length>0'
                          [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                          <div class="sig-chrome"
                            [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                            <div class="sig-chrome-title-top ng-scope" translate="flowtrics by:">By flowtrics</div>
                            <div class="sig-container"
                              [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                              <img *ngIf='field.signatureBase64' [src]="field.signatureBase64" />
                              <ng-container *ngIf='field.signatureText && !field.signatureBase64'>
                                <h3 [ngStyle]="{'font-family': field.signInitialFontFamily}">{{field.signatureText}}
                                </h3>
                              </ng-container>

                              <div *ngFor="let img of field.ImageData" class="uploadedData"
                                [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                                <img [src]="img.Imageurl" [class.disabled]="field.isDisabled" />
                              </div>

                            </div>
                            <div class="sig-chrome-title-bottom ng-binding">{{field.participantEmailId}}</div>
                          </div>
                        </div>
                        <!-- Signature Stamp-->
                      </div>

                      <div matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}"
                        matTooltipShowDelay="2500" matTooltipClass="tooltip" *ngIf="!field.isDisabled"
                        [class.disabled]="field.isDisabled" id="{{field.id}}" class="customUpdate"
                        [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"
                        [ngClass]="{'bnone' : field.signatureBase64 || field.signatureText && !field.signatureBase64 || field.ImageData.length>0 }"
                        (click)="OpenSignPopup(AddSignature,item,field)">
                        <span id="border_color"
                          *ngIf='!field.signatureBase64 && !field.signatureText && field.ImageData.length==0'>
                          <mat-icon>border_color</mat-icon>
                          Signature
                        </span>

                        <!-- Signature Stamp-->
                        <div class="sig-cell"
                          *ngIf='field.signatureBase64 || field.signatureText && !field.signatureBase64 || field.ImageData.length>0'
                          [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                          <div class="sig-chrome"
                            [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                            <div class="sig-chrome-title-top ng-scope" translate="flowtrics by:">By flowtrics</div>
                            <div class="sig-container"
                              [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                              <img *ngIf='field.signatureBase64' [src]="field.signatureBase64" />
                              <ng-container *ngIf='field.signatureText && !field.signatureBase64'>
                                <h3 [ngStyle]="{'font-family': field.signInitialFontFamily}">{{field.signatureText}}
                                </h3>
                              </ng-container>

                              <div *ngFor="let img of field.ImageData" class="uploadedData"
                                [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                                <img [src]="img.Imageurl" [class.disabled]="field.isDisabled" />
                              </div>
                            </div>
                            <div class="sig-chrome-title-bottom ng-binding">{{field.participantEmailId}}</div>
                          </div>
                        </div>
                        <!-- Signature Stamp-->
                      </div>
                    </ng-container>

                    <ng-container *ngIf="field.fieldTypeName=='Initials' && field.Control=='Static'">
                      <div matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}"
                        matTooltipShowDelay="2500" matTooltipClass="tooltip" *ngIf="field.isDisabled"
                        style="background-color:#dddddd;cursor: not-allowed; pointer-events: all !important;border: 2px solid rgba(118, 118, 118, 0.3)!important;"
                        [class.disabled]="field.isDisabled" id="{{field.id}}" class="customUpdate"
                        [ngClass]="{'ng-active' : field.ShowtoolDetail}">
                        <span id="initial_gesture"
                          *ngIf='!field.signatureBase64 && !field.signatureText && field.ImageData.length==0'
                          style="cursor: not-allowed; pointer-events: all !important;">
                          <mat-icon>gesture</mat-icon>
                          Initials
                        </span>
                        <!-- Initials Stamp-->
                        <div class="sig-cell"
                          *ngIf='field.signatureBase64 || field.signatureText && !field.signatureBase64 || field.ImageData.length>0'
                          [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                          <div class="sig-chrome"
                            [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                            <div class="sig-chrome-title-top ng-scope" translate="flowtrics by:">By flowtrics</div>
                            <div class="sig-container"
                              [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                              <img *ngIf='field.signatureBase64' [src]="field.signatureBase64" />
                              <ng-container *ngIf='field.signatureText && !field.signatureBase64'>
                                <h3 [ngStyle]="{'font-family': field.signInitialFontFamily}">{{field.signatureText}}
                                </h3>
                              </ng-container>

                              <div *ngFor="let img of field.ImageData" class="uploadedData"
                                [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                                <img [src]="img.Imageurl" [class.disabled]="field.isDisabled" />
                              </div>

                            </div>
                            <div class="sig-chrome-title-bottom ng-binding">{{field.participantEmailId}}</div>
                          </div>
                        </div>
                        <!-- Initials Stamp-->

                      </div>

                      <div matTooltip="{{field.folderName!=='' && field.folderName!==undefined?field.folderName:null }}"
                        matTooltipShowDelay="2500" matTooltipClass="tooltip" *ngIf="!field.isDisabled"
                        [class.disabled]="field.isDisabled" id="{{field.id}}" class="customUpdate"
                        [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"
                        [ngClass]="{'bnone' : field.signatureBase64 || field.signatureText && !field.signatureBase64 || field.ImageData.length>0 }"
                        (click)="OpenSignPopup(AddInitial,item,field)">
                        <span id="initial_gesture"
                          *ngIf='!field.signatureBase64 && !field.signatureText && field.ImageData.length==0'>
                          <mat-icon>gesture</mat-icon>
                          Initials
                        </span>

                        <!-- Initials Stamp-->
                        <div class="sig-cell"
                          *ngIf='field.signatureBase64 || field.signatureText && !field.signatureBase64 || field.ImageData.length>0'
                          [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                          <div class="sig-chrome"
                            [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                            <div class="sig-chrome-title-top ng-scope" translate="flowtrics by:">By flowtrics</div>
                            <div class="sig-container">
                              <img *ngIf='field.signatureBase64' [src]="field.signatureBase64" />
                              <ng-container *ngIf='field.signatureText && !field.signatureBase64'>
                                <h3 [ngStyle]="{'font-family': field.signInitialFontFamily}">{{field.signatureText}}
                                </h3>
                              </ng-container>

                              <div *ngFor="let img of field.ImageData" class="uploadedData"
                                [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}">
                                <img [src]="img.Imageurl" [class.disabled]="field.isDisabled" />
                              </div>

                            </div>
                            <div class="sig-chrome-title-bottom ng-binding">{{field.participantEmailId}}</div>
                          </div>
                        </div>
                        <!-- Initials Stamp-->

                      </div>
                    </ng-container>

                  </div>
                </div>
              </ng-container>

            </ng-container>

            <img *ngIf='imageHeight!=0 && imageWidth!=0' [src]="item.img" alt=""
              [ngStyle]="{ 'width':imageWidth +'px', 'height':imageHeight+'px'}" [ngClass]="{'progress': waitPointer}"
              id="imgSrc{{i}}" (click)="onClickonImage($event,item)">
            <img *ngIf='imageHeight==0 && imageWidth==0' [src]="item.img" alt=""
              [ngStyle]="{ 'width':imageWidth +'px', 'height':imageHeight+'px'}" [ngClass]="{'progress': waitPointer}"
              id="imgSrc{{i}}" (click)="onClickonImage($event,item)">

            <div id="imageDrawContainer" (click)="onClickonImage($event,item)"
              style="position: absolute;left: 0px; top: 0px;" *ngFor="let imgDrawn of item.drawings"
              [innerHtml]="imgDrawn">

            </div>
          </div>
        </div>

       

      </div>
    </div>

  </div>

  <mat-card class="rblockPanel" *ngIf="isPageLoaded" [ngClass]="{'open' : showFiles}">
   
    <button mat-icon-button color="warn" class="closeRight"   (click)="showAllFiles()"><mat-icon>close</mat-icon> </button>

  <div class="allpages">
      <div class="allpagesName">
        <ng-container *ngFor="let p of pjtDocumentImgThumbs ;let i = index">
          <div class="icoName" [ngClass]="{'active' : p.documentID==selectedDocumentId}"
            (click)='FillDocImagesWithFields(p.documentID,true,i)'>
            <mat-icon>description</mat-icon>
            <span class="pdfdocnames">{{p.documentName}}</span>
          </div>
        </ng-container>
      </div>

      <div class="viewPages">
        <div class="pageDetail" *ngFor="let p of thumbNailImages ;let i = index">
          <div class="page" (click)='scrollToPage(i+1)'>
            <span>{{p.pageNumber}}</span>
            <img [src]="p.imageUrl" alt="" />
          </div>
        </div>
      </div>
  </div>

  </mat-card>



  <div class="rblockOverlay" [ngClass]="{'open' : showFiles}" (click)="showAllFiles()"></div>
</div>

<div class="allpages bottomNavigation">

  <div class="finishBtn">

    <button class="finish" color="primary"  [attr.disabled]="IsSigningComplete"
      (click)="SignatureAcceptance(acceptFinish)" mat-flat-button>Finish
    </button>
  </div>

  <div class="allpagesName">
    <ng-container *ngFor="let p of pjtDocumentImgThumbs ;let i = index">

      <div class="icoName" [ngClass]="{'active' : p.documentID==selectedDocumentId}"
        (click)='FillDocImagesWithFields(p.documentID,true,i)'>

        <span *ngFor="let thumb of setDocWithImageCount ;let j = index" >

          <ng-container *ngIf="p.documentID == thumb.docId">
            <div class="page">
              <span [ngStyle]="{'background-color': thumb.isComplete ? 'green' : 'red' }" >{{thumb.pageCount}}</span>
              <img [src]="thumb.thumbnail" alt="" />
            </div>
          </ng-container>


        </span>

      </div>
    </ng-container>
  </div>

  <div class="finishBtn">
    <button class="nextBtn_Blue" color="primary"
            (click)="movetoNextControl()" mat-flat-button >Next  <mat-icon>arrow_forward_ios</mat-icon>
     </button>
  </div>

  
</div>

<ng-template #signature>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>text_snippet</mat-icon></span>
    Add Signature2
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <div class="radOpts">
      <mat-radio-group aria-label="Select an option" color="primary" [(ngModel)]="signOpt">
        <mat-radio-button value="draw">Draw</mat-radio-button>
        <mat-radio-button value="upload">Upload</mat-radio-button>
        <mat-radio-button value="type">Type In</mat-radio-button>
      </mat-radio-group>

    </div>

    <div class="allSCont">
      <ng-container *ngIf="signOpt == 'upload'">
        <div class="uploadholder">
          <mat-icon>note_add</mat-icon>
          <p>Drop your signature here or click here to upload</p>
          <span>File extension should be .png</span>
          <input type="file" />
        </div>
      </ng-container>

      <ng-container *ngIf="signOpt == 'draw'">
        <signature-pad [options]="signaturePadOptions" (onBeginEvent)="drawStart()"
          (onEndEvent)="drawComplete()"></signature-pad>
      </ng-container>

      <ng-container *ngIf="signOpt == 'type'">
        <div class="divideCol">
          <div class="left blk">
            <mat-form-field class="example-full-width">
              <mat-label>Enter Name</mat-label>
              <input matInput required placeholder="Enter name" value="" [(ngModel)]="signName">
            </mat-form-field>
          </div>
          <div class="right blk">
            <mat-form-field class="example-full-width">
              <mat-label>Select Font</mat-label>
              <select matNativeControl required>
                <option value="1">Roboto</option>
                <option value="2">Signature 1</option>
                <option value="3">Signature 2</option>
                <option value="3">Signature 3</option>
              </select>
            </mat-form-field>
          </div>
        </div>
        <div class="allSign">
          <div class="signlook" style="font-family: 'Indie Flower', cursive;">
            {{signName}}
          </div>
        </div>
      </ng-container>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="close()" class="clear" color="warn">Clear</button>
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary">Save</button>
  </mat-dialog-actions>
</ng-template>


<ng-template #acceptFinish>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>how_to_reg</mat-icon></span>
    Signature Acceptance
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">

    <h3>By clicking “Sign” in Flowtrics, I acknowledge that my electronic signature is legally binding under ESIGN/UETA and accept full responsibility for every action or obligation authorized by it. </h3>

  </mat-dialog-content>
  <mat-dialog-actions>
    
    <button mat-button (click)="close()" >Cancel</button>    
    <button mat-flat-button color="primary" [disabled]='isAcceptButtonDisabled'
      (click)="AcceptBtnClick()">Accept</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #AddSignature>
  <h2 mat-dialog-title class="signTitle">  
    <ng-container *ngIf="hasSignature">My Signature</ng-container>
    <ng-container *ngIf="!hasSignature">Adopt your signature</ng-container>

    <ng-container *ngIf="hasSignature">
      <button mat-flat-button class="addNewSignButton" color="primary" (click)="addNewSignature()" [disabled]="fiveSignaturesLimitReached"  >
      <mat-icon>add</mat-icon> Add signature
    </button>
    </ng-container>
    <ng-container *ngIf="!hasSignature">
      <button mat-stroked-button class="addNewSignButton" color="primary" (click)="addNewSignature()" [disabled]="fiveSignaturesLimitReached"  >
      <mat-icon>arrow_back</mat-icon> Back
      </button>
    </ng-container>

    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <ng-container >

    <mat-dialog-content class="mat-typography">
      <div class="tabConainer">

        <ng-container *ngIf="!hasSignature" >
          <!-- new signature add options -->
        <div class="signatureOptions" >

          <div class="drawSignature" [ngClass]="{'active': signOpt == 'draw'}" (click)="signatureType('draw')" >
            <div class="icon">
              <img src="./../../../assets/images/signature.png" alt="">
            </div>
            <div class="info">
              <h3>Draw your signature</h3>
              <p>Draw your signature here using your mouse or trackpad.</p>
            </div>
          </div>


          <div class="drawSignature" [ngClass]="{'active': signOpt == 'uploads'}" (click)="signatureType('upload')">
            <div class="icon">
              <img src="./../../../assets/images/uploadIcon.png" alt="">
            </div>
            <div class="info">
              <h3>Upload your signature</h3>
              <p>Upload an image on your handwritten signature here.</p>
            </div>
          </div>

          <div class="drawSignature" [ngClass]="{'active': signOpt == 'type'}" (click)="signatureType('type')">
            <div class="icon">
              <img src="./../../../assets/images/typeIn.png" alt="">
            </div>
            <div class="info">
              <h3>Type in your signature</h3>
              <p>Add your name and select any font.</p>
            </div>
          </div>

        </div>
        <!-- new signature add options -->


        <!-- new signature Preview & Holder -->
        <div class="previewHolder">
          <h3 class="preview_text" >PREVIEW</h3>
        <div class="previewContainer">
          <ng-container *ngIf="signOpt == 'upload'">
            <div class="uploadholderSignature">
              <!-- <mat-icon>note_add</mat-icon> -->
              <img src="./../../../assets/images/uploadIcon.png" alt="" width="60" >
              <p *ngIf="filenameForSign == '' ">Upload your signature</p>
              <span *ngIf="filenameForSign == '' ">Upload an png image on your handwritten signature here</span>
              <p>{{filenameForSign}}</p>
              <input type="file" class="form-control" accept="image/*" (change)="onSelectSignImage($event,'','')"
                placeholder="Add file">
            </div>
          </ng-container>

          <ng-container *ngIf="signOpt == 'draw'">
            <signature-pad [options]="signaturePadOptions" (onBeginEvent)="drawStart()"
              (onEndEvent)="drawComplete()"></signature-pad>
          </ng-container>

          <ng-container *ngIf="signOpt == 'type'">
            <div class="divideCol">
              <div class="left blk">
                <mat-form-field>
                  <mat-label>Enter Signature Name</mat-label>
                  <input matInput required placeholder="Enter signature name" value="" [(ngModel)]="signName"
                    (ngModelChange)="signOrInitialTextChanges($event)">
                </mat-form-field>
              </div>
              <div class="right blk">
                <mat-form-field appearance="fill">
                  <mat-label>Select font family</mat-label>
                  <mat-select [(value)]="selected" (selectionChange)="setSignInitialFontFamilyChange($event.value)">
                    <mat-option *ngFor="let fam of family; index as i" value="{{fam.font}}">{{fam.font}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="allSign">
              <div class="signlook" [ngStyle]="{'font-family': signInitialFontFamily }">
                {{signName}}
              </div>
              <style>
                @import 'https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap';
              </style>
            </div>
          </ng-container>
        </div>
        </div>
        <!-- new signature Preview & Holder -->
        </ng-container>



        <div *ngIf="hasSignature" class="signatureListHolder">

          <span class="limitReached" *ngIf="fiveSignaturesLimitReached" >You can add upto 5 signatures only. Please delete a signature if you want to add new.</span>

          <div *ngFor="let img of getAllSignatures" class="signatureList">

            <div class="uploadedData"  (click)="selectedSignature(img)" [ngClass]="{ 'active': signatureID === img.signatureID || img.isDefault == true }">

              <mat-icon class="unselect">radio_button_unchecked</mat-icon>
              <mat-icon class="select">check_circle</mat-icon>

              <div class="sig-cell">
                <div class="sig-chrome">
                  <div class="sig-chrome-title-top ng-scope" translate="flowtrics by:">By flowtrics</div>
                  <div class="sig-container">

                    <ng-container *ngIf="img.signature.type=='Draw'">
                      <div class="signature">
                        <img [src]="img.signature.signatureBase64"/>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="img.signature.type=='Upload'">
                      <div *ngFor="let img1 of img.signature.ImageData" class="signature">
                        <img [src]="img1.Imageurl"/>
                      </div>
                    </ng-container>


                    <ng-container *ngIf="img.signature.type=='Type In'">
                      <div class="signature">
                        <h3 [ngStyle]="{'font-family': img.signature.signInitialFontFamily}">
                          {{img.signature.signatureText}}</h3>
                      </div>
                    </ng-container>

                  </div>
                  <div class="sig-chrome-title-bottom ng-binding">email id</div>
                </div>
              </div>

              <button mat-icon-button class="closeIcon" (click)="deleteSignature(img)"><mat-icon>close</mat-icon></button>
            </div>

          </div>
      </div>




      </div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button (click)="close()">Cancel</button>
      <span>
        <button *ngIf="signOpt == 'draw' && !hasSignature" mat-stroked-button color="primary" (click)="clearSignature()">Clear</button>

        <!-- [disabled]="getAllSignatures.length==0" -->
        <button *ngIf="hasSignature" mat-flat-button (click)="addDefaultSignature()"   color="primary">Adopt &  Sign</button>

        <button *ngIf="!hasSignature" mat-flat-button (click)="addSignature()" color="primary" [disabled]="!SignButtonEnable">Adopt &  Sign</button>
      </span>
    </mat-dialog-actions>
  </ng-container>

</ng-template>

<ng-template #Draw>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>brush</mat-icon>
    </span>
    Draw
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <div class="tabConainer">
      <div class="allSCont">
        <ng-container>
          <signature-pad id="drawCanvas" [options]="signaturePadOptions" (onBeginEvent)="drawStart()"
            (onEndEvent)="drawComplete()"></signature-pad>
        </ng-container>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button (click)="addDrawnImg()" [disabled]="!DrawButtonEnable" color="primary">Save</button>
  </mat-dialog-actions>
</ng-template>



<ng-template #AddInitial>
  <h2 mat-dialog-title class="signTitle">

    <ng-container *ngIf="hasInitials">My Initial</ng-container>
    <ng-container *ngIf="!hasInitials">Adopt your Initial</ng-container>

    <ng-container *ngIf="hasInitials">
      <button mat-flat-button class="addNewSignButton" color="primary" (click)="addNewInitial()" [disabled]="fiveInitialsLimitReached">
      <mat-icon>add</mat-icon> Add initial
    </button>
    </ng-container>
    <ng-container *ngIf="!hasInitials">
      <button mat-stroked-button class="addNewSignButton" color="primary" (click)="addNewInitial()" [disabled]="fiveInitialsLimitReached">
      <mat-icon>arrow_back</mat-icon> Back
      </button>
    </ng-container>

    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <ng-container>

    <mat-dialog-content class="mat-typography">
      <div class="tabConainer">

        <ng-container *ngIf="!hasInitials">
          <!-- new signature add options -->
        <div class="signatureOptions">

          <div class="drawSignature" [ngClass]="{'active': signOpt == 'draw'}" (click)="signatureType('draw')" >
            <div class="icon">
              <img src="./../../../assets/images/signature.png" alt="">
            </div>
            <div class="info">
              <h3>Draw your initial</h3>
              <p>Draw your initial here using your mouse or trackpad.</p>
            </div>
          </div>


          <div class="drawSignature" [ngClass]="{'active': signOpt == 'uploads'}" (click)="signatureType('upload')">
            <div class="icon">
              <img src="./../../../assets/images/uploadIcon.png" alt="">
            </div>
            <div class="info">
              <h3>Upload your initial</h3>
              <p>Upload an image on your handwritten initial here.</p>
            </div>
          </div>

          <div class="drawSignature" [ngClass]="{'active': signOpt == 'type'}" (click)="signatureType('type')">
            <div class="icon">
              <img src="./../../../assets/images/typeIn.png" alt="">
            </div>
            <div class="info">
              <h3>Type in your initial</h3>
              <p>Add your name and select any font.</p>
            </div>
          </div>

        </div>
        <!-- new signature add options -->


        <!-- new signature Preview & Holder -->
        <div class="previewHolder">
          <h3 class="preview_text" >PREVIEW</h3>
        <div class="previewContainer">
          <ng-container *ngIf="signOpt == 'upload'">
            <div class="uploadholderSignature">
              <img src="./../../../assets/images/uploadIcon.png" alt="" width="60" >
              <p *ngIf="filenameForSign == '' ">Upload your initial</p>
              <span *ngIf="filenameForSign == '' ">Upload an png image on your handwritten initial here</span>
              <p>{{filenameForSign}}</p>
              <input type="file" class="form-control" accept="image/*" (change)="onSelectSignImage($event,'','')"
                placeholder="Add file">
            </div>
          </ng-container>

          <ng-container *ngIf="signOpt == 'draw'">
            <signature-pad [options]="signaturePadOptions" (onBeginEvent)="drawStart()"
              (onEndEvent)="drawComplete()"></signature-pad>
          </ng-container>

          <ng-container *ngIf="signOpt == 'type'">
            <div class="divideCol">
              <div class="left blk">
                <mat-form-field>
                  <mat-label>Enter Initial Name</mat-label>
                  <input matInput required placeholder="Enter initial name" value="" [(ngModel)]="signName"
                    (ngModelChange)="signOrInitialTextChanges($event)">
                </mat-form-field>
              </div>
              <div class="right blk">
                <mat-form-field appearance="fill">
                  <mat-label>Select font family</mat-label>
                  <mat-select [(value)]="selected" (selectionChange)="setSignInitialFontFamilyChange($event.value)">
                    <mat-option *ngFor="let fam of family; index as i" value="{{fam.font}}">{{fam.font}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="allSign">
              <div class="signlook" [ngStyle]="{'font-family': signInitialFontFamily }">
                {{signName}}
              </div>
              <style>
                @import 'https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap';
              </style>
            </div>
          </ng-container>
        </div>
        </div>
        <!-- new signature Preview & Holder -->
        </ng-container>



        <div *ngIf="hasInitials" class="signatureListHolder">

        <span class="limitReached" *ngIf="fiveInitialsLimitReached">You can add upto 5 initials only. Please delete a initials if you want to add new.</span>

          <div *ngFor="let img of getAllInitials" class="signatureList">

            <div class="uploadedData" [ngClass]="{ 'active': InitialsID === img.initialID || img.isDefault == true }">

              <mat-icon class="unselect">radio_button_unchecked</mat-icon>
              <mat-icon class="select">check_circle</mat-icon>

              <div class="sig-cell">
                <div class="sig-chrome">
                  <div class="sig-chrome-title-top ng-scope" translate="flowtrics by:">By flowtrics</div>
                  <div class="sig-container" (click)="selectedInitials(img)">

                    <ng-container *ngIf="img.initial.type=='Draw'">
                      <div class="signature">
                        <img [src]="img.initial.signatureBase64"/>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="img.initial.type=='Upload'">
                      <div *ngFor="let img1 of img.initial.ImageData" class="signature">
                        <img [src]="img1.Imageurl"/>
                      </div>
                    </ng-container>


                    <ng-container *ngIf="img.initial.type=='Type In'">
                      <div class="signature">
                        <h3 [ngStyle]="{'font-family': img.initial.signInitialFontFamily}">
                          {{img.initial.signatureText}}</h3>
                      </div>
                    </ng-container>

                  </div>
                  <div class="sig-chrome-title-bottom ng-binding">email id</div>
                </div>
              </div>

              <button mat-icon-button class="closeIcon" (click)="deleteInitails(img)"><mat-icon>close</mat-icon></button>
            </div>

          </div>
      </div>




      </div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button (click)="close()">Cancel</button>
      <span>
        <button *ngIf="signOpt == 'draw' && !hasInitials" mat-stroked-button color="primary" (click)="clearInitail()">Clear</button>
         <!-- [disabled]="getAllInitials.length==0" -->
        <button *ngIf="hasInitials" mat-flat-button (click)="addDefaultInitials()" color="primary">Adopt &  Sign</button>

        <button *ngIf="!hasInitials" mat-flat-button (click)="addInitails()" color="primary" [disabled]="!InitailButtonEnable">Adopt &  Sign</button>
      </span>
    </mat-dialog-actions>
  </ng-container>

</ng-template>



<!-- *ngIf="spinner" -->
 <div class="outerLoader" *ngIf="spinner">
  <div id="container" >
    <div class="divider" aria-hidden="true"></div>
    <p class="loading-text" aria-label="Loading">
      <span class="letter" aria-hidden="true">L</span>
      <span class="letter" aria-hidden="true">o</span>
      <span class="letter" aria-hidden="true">a</span>
      <span class="letter" aria-hidden="true">d</span>
      <span class="letter" aria-hidden="true">i</span>
      <span class="letter" aria-hidden="true">n</span>
      <span class="letter" aria-hidden="true">g</span>
    </p>
  </div>
 </div>


<app-loader></app-loader>